module.exports = __webpack_public_path__ + "static/cloud-6513f0f4e69a59ee8f410ad7e04ce5ec.png";